"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "Fredag",
    "MONDAY": "Måndag",
    "SATURDAY": "Lördag",
    "SUNDAY": "Söndag",
    "THURSDAY": "Torsdag",
    "TUESDAY": "Tisdag",
    "WEDNESDAY": "Onsdag",
    "and": "och",
    "day": "dag",
    "day_one": "dag",
    "day_other": "dagar",
    "day_plural": "dagar",
    "freeOfCharge": "Gratis",
    "hour_one": "timme",
    "hour_one_plural": "timmar",
    "hour_other": "timmar",
    "minute": "minut",
    "minute_one": "minut",
    "minute_other": "minuter",
    "ocpiRestrictionsAfterDuration": "Efter {{minDuration}}",
    "ocpiRestrictionsBetweenDuration": "Mellan {{minDuration}} och {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "Första {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "När energianvändningen är mer än {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "När energianvändningen är mellan {{minKwh}} och {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "När energianvändningen är mindre än {{maxKwh}}",
    "session": "session",
    "theDay": "dagen",
    "theDay_one": "dagen",
    "theDay_other": "dagarna",
    "theHour": "timmen",
    "theHour_one": "timmen",
    "theHour_other": "timmarna",
    "theMinute": "minuten",
    "theMinute_one": "minuten",
    "theMinute_other": "minuterna"
};
